


























































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class AmazonMarketplaceWidget extends Vue {
  custodianStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();

  @Prop()
  width: number;

  @Prop()
  height: number;

  displayExternalLinkModal = false;
  modalExternalLinkUrl;


  linkNavigate (url) {
    const internalLinkRegex = new RegExp("https://[a-z]*\\.hsabank\\.com", "gi");
    if (internalLinkRegex.test(url)) {
      window.open(url, "_blank");
    }
    else {
      this.displayExternalLinkModal = true;
      this.modalExternalLinkUrl = url;
    }
  }

  @Watch("portalCustomizationStore.partnerId")
  refreshPartner () {
    this.portalCustomizationStore.getHsaStoreInfo(this.portalCustomizationStore.partnerId);
  }

  mounted (): void {
    this.portalCustomizationStore.getHsaStoreInfo(this.portalCustomizationStore.partnerId);
  }

  onCancel () {
    this.displayExternalLinkModal = false;
  }

  onSubmit (url) {
    this.displayExternalLinkModal = false;
    window.open(url, "_blank");
  }
}
